
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
components: {
XHeader,
XInput,
Group,
XTextarea
},
name: 'orderDetail',
data() {
return {
orderDetail: {},
address: ''
}
},
beforeRouteEnter(to, from, next) {
next(vm => {
let obj = {
headers: {
opid: 1
}
}
AjaxPlugin.$http.get('api/v1/fastrepairs/' + to.query.seq, obj).then(response => {
localStorage.setItem('order', JSON.stringify(response.data.detail))
vm.orderDetail = response.data.detail
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.isviwo) {
vm.orderDetail.isviwo = '是'
} else {
vm.orderDetail.isviwo = '否'
}
}).catch(error => {
console.log(error)
vm.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/quicklycomplete.vue